import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class VendorService {
  private apiUrl = environment.apiBaseUrl +'/api/Vendors';
  constructor(private http: HttpClient, private authService: AuthService) {
  }


  register(vendor: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/Register`, vendor);
  }


  getMyProfile(): Observable<any> {
    return this.http.get(`${this.apiUrl}/MyProfile`);
  }


  updateProfile(vendor: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/UpdateProfile`, vendor);
  }


  // Admin
  getAllVendors(): Observable<any> {
    return this.http.get(this.apiUrl);
  }


  approveVendor(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/Approve/${id}`, {});
  }


  rejectVendor(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/Reject/${id}`, {});
  }

  deleteVendor(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}

